import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=3948ee40&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"
import style0 from "./remark.vue?vue&type=style&index=0&id=3948ee40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948ee40",
  null
  
)

export default component.exports